import { Center, Container, Loader, Stack } from '@mantine/core'

export default function Pending() {
  return (
    <Container fluid h={400}>
      <Center h={400}>
        <Stack align="center">
          <Loader />
          <p>Loading...</p>
        </Stack>
      </Center>
    </Container>
  )
}
